module.exports = __webpack_public_path__ + "static/media/(LH)-06-Capim-Dourado-bijuterias.df862824.jpg";